import { Application } from 'app/shared/services/app/application/application.model';
import { UserApplicationProperties, RoleType } from './user-application-properties.model';
import { BaseUser } from './base-user.model';

export class ActiveUser extends BaseUser {
  applications: Application[] = [];
  appHash: any = {};
  roles: UserApplicationProperties[] = [];
  avatarUrl: string = '';
  company: string = '';

  permissions: any = [];
  canCreateApps: boolean = false;

  remoteCache: any = {};
  readArticleIds: number[] = [];
  lastViewedDashboard: Date = null;

  viewedWalkthroughs: string[] = [];

  token: string = '';

  constructor(json?: any) {
    super(json || null);
    if (json) {
      this.avatarUrl = json.avatar_url || '';
      this.company = json.company || '';

      this.permissions = json.permissions || [];
      this.canCreateApps = json.permissions && this.permissions.indexOf('create_apps') > -1;

      if (json.remote_cache) {
        this.updateRemoteCacheProperties(json.remote_cache);
      }

      this.token = json.token || '';
    }
  }

  // for initialization, to prevent having to write checks elsewhere
  fetchCacheData(property: string) {
    if (this.remoteCache.hasOwnProperty(property)) return this.remoteCache[property];
    return null;
  }

  hasApplication(sysName: string): boolean {
    return this.appHash[sysName];
  }

  hasFeaturePermission(sysName: string, feature: string) {
    if (!this.hasApplication(sysName)) return false;
    let appToCheck = this.appHash[sysName];
    let featureStrings = appToCheck.permissions;
    return featureStrings.indexOf(feature) > -1;
  }

  getLocalUserRole(sysName: string): RoleType {
    let appRoles = this.roles.filter(role => role.application.sys_name === sysName);
    return appRoles.length ? appRoles[0].level : null;
  }

  updateRemoteCacheProperties(cacheJson: any) {
    this.remoteCache = cacheJson;
    this.readArticleIds = this.fetchCacheData('read_article_ids') || [];
    this.lastViewedDashboard = new Date(this.fetchCacheData('last_article_date'));
    this.viewedWalkthroughs = this.fetchCacheData('viewed_walkthroughs') || [];
  }

  toJson() {
    let json: any = {
      id: this.id,
      first_name: this.lastName,
      last_name: this.lastName,
      email: this.email,
      avatar_url: this.avatarUrl,
      company: this.company,
      apps: this.roles.map(role => role.toJson()),
      permissions: this.permissions,
      remote_cache: {
        unread_article_ids: this.readArticleIds,
        last_article_date: this.lastViewedDashboard.toISOString()
      }
    };
    return json;
  }

  copy() {
    return new ActiveUser(this.toJson());
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/active-user.model.ts